import './setPublicPath';
export type { WindowOauth2, TokenSet } from './types';
export type { ClientConfig } from './configuration';
import { DebugLogger } from './utils/logger';
import { pingamClient } from './client';

// Auto-bind to window.oauth2 when loaded in browser environment
// The pingamClient object is synchronously available (methods handle async initialization internally)
if (typeof window !== 'undefined') {
  if ((window as any)?.oauth2) {
    DebugLogger.error('window.oauth2 already bound');
  } else {
    (window as any).oauth2 = pingamClient;
    DebugLogger.info('Bound to window.oauth2');
  }
}

// Also export for direct import
export { pingamClient } from './client';
